export default __webpack_public_path__ + "static/media/WarningIcon.ef3a8125.svg";